<template>
  <div>
    <div id="head-contact" class="bg-grad">
      <h2 class="text-white">
        {{ $t("zoneIntervention.header.title") }}
      </h2>
    </div>

    <section class="mt-5">
      <div class="container">
        <!-- TITRE -->
        <div class="mb-5">
          <h2 class="fw-bold text-primary">
            {{ $t("zoneIntervention.intro.title") }}
          </h2>
          <p class="mt-3" style="font-size: 1.15rem; line-height: 1.7">
            {{ $t("zoneIntervention.intro.p1") }}
          </p>
        </div>

        <!-- CARDS PRINCIPALES -->
        <div class="row g-4">
          <!-- Wallonie -->
          <div class="col-md-4">
            <div class="radiusborder shadow-sm h-100">
              <div class="card-body">
                <h4 class="card-title text-primary">
                  {{ $t("zoneIntervention.cards.wallonie.title") }}
                </h4>
                <p
                  class="card-text"
                  style="font-size: 1.15rem; line-height: 1.7"
                >
                  {{ $t("zoneIntervention.cards.wallonie.p1.beforeStrong") }}
                  <strong>{{
                    $t("zoneIntervention.cards.wallonie.p1.strong")
                  }}</strong>
                  {{ $t("zoneIntervention.cards.wallonie.p1.afterStrong") }}
                </p>
              </div>
            </div>
          </div>

          <!-- Bruxelles -->
          <div class="col-md-4">
            <div class="radiusborder shadow-sm h-100">
              <div class="card-body">
                <h4 class="card-title text-primary">
                  {{ $t("zoneIntervention.cards.bruxelles.title") }}
                </h4>
                <p
                  class="card-text"
                  style="font-size: 1.15rem; line-height: 1.7"
                >
                  {{ $t("zoneIntervention.cards.bruxelles.p1") }}
                </p>
              </div>
            </div>
          </div>

          <!-- Flandre -->
          <div class="col-md-4">
            <div class="radiusborder shadow-sm h-100">
              <div class="card-body">
                <h4 class="card-title text-primary">
                  {{ $t("zoneIntervention.cards.flandre.title") }}
                </h4>
                <p
                  class="card-text"
                  style="font-size: 1.15rem; line-height: 1.7"
                >
                  {{ $t("zoneIntervention.cards.flandre.p1") }}
                </p>
              </div>
            </div>
          </div>

          <!-- Résidences secondaires -->
          <div class="col-md-12">
            <div class="radiusborder shadow-sm h-100">
              <div class="card-body">
                <h4 class="card-title text-primary">
                  {{ $t("zoneIntervention.cards.residencesSecondaires.title") }}
                </h4>
                <p
                  class="card-text"
                  style="font-size: 1.15rem; line-height: 1.7"
                >
                  {{
                    $t(
                      "zoneIntervention.cards.residencesSecondaires.p1.beforeStrong"
                    )
                  }}
                  <strong>{{
                    $t("zoneIntervention.cards.residencesSecondaires.p1.strong")
                  }}</strong>
                  {{
                    $t(
                      "zoneIntervention.cards.residencesSecondaires.p1.afterStrong"
                    )
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- BLOC ADDITIONNEL -->
        <div class="row mt-5">
          <div class="col-lg-6">
            <div
              class="p-4 radiusborder shadow-sm h-100"
              style="font-size: 1.15rem; line-height: 1.7"
            >
              <h4 class="fw-bold text-primary">
                {{ $t("zoneIntervention.mobileTeam.title") }}
              </h4>
              <p>
                {{ $t("zoneIntervention.mobileTeam.p1") }}
              </p>
              <ul>
                <li>{{ $t("zoneIntervention.mobileTeam.list.item1") }}</li>
                <li>{{ $t("zoneIntervention.mobileTeam.list.item2") }}</li>
                <li>{{ $t("zoneIntervention.mobileTeam.list.item3") }}</li>
                <li>{{ $t("zoneIntervention.mobileTeam.list.item4") }}</li>
              </ul>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="p-4 h-100" style="font-size: 1.15rem; line-height: 1.7">
              <h4 class="fw-bold text-primary">
                {{ $t("zoneIntervention.mapBlock.title") }}
              </h4>
              <img
                src="@/assets/img/zoneintervention.png"
                :alt="$t('zoneIntervention.mapBlock.imageAlt')"
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- CALL TO ACTION -->
    <Cta />
  </div>
</template>

<script>
import { useHead } from "@vueuse/head";
import { useI18n } from "vue-i18n";

import Cta from "@/components/Cta.vue";

export default {
  name: "ZoneIntervention",
  components: {
    Cta,
  },
  setup() {
    const { t } = useI18n();

    useHead(() => ({
      title: t("zoneIntervention.meta-data.title"),
      meta: [
        {
          name: "description",
          content: t("zoneIntervention.meta-data.desc"),
        },
      ],
    }));
  },
};
</script>

<style scoped>
#head-contact {
  color: white;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
